module.exports = __webpack_public_path__ + "img/hot.21172cf8.png";